module.exports = __webpack_public_path__ + "cement/img/dev_img.d477ec61.png";